import React from 'react';
import { apiGetPhoto, apiGetPhotoList, apiIsLoggedIn } from '../api/api';
import { useParams } from 'react-router-dom';
import ReunionPhotosTable from '../components/tables/ReunionPhotos/ReunionPhotosTable';
import TopBarReunionPhotos from '../components/topbars/TopBarReunionPhotos';

function withParams(Component) {
    return props => <Component {...props} params={useParams()} />;
}

class ReunionPhotoPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoggedIn: false,
            photoList: null,
        }
    }

    async componentDidMount() {
        const isLoggedIn = await apiIsLoggedIn();
        if (!isLoggedIn) {
            window.location.href = '/';
        }

        const photoListResponse = await apiGetPhotoList(this.props.params.folder);
        if (photoListResponse.ok) {
            const photoListResponseJson = await photoListResponse.json();

            this.setState({
                ...this.state,
                photoList: photoListResponseJson.photo_list,
            });
        }
    }

    render() {
        return (
            <div>
                {/* Oof, this way of getting year is pretty fragile */}
                <TopBarReunionPhotos year={this.props.params.folder.split("-")[1]}/>
                {this.state.photoList ? <ReunionPhotosTable photoList={this.state.photoList}/> : <p>Loading...</p> }
            </div>
        )
    }
}

export default withParams(ReunionPhotoPage);
